import React, {useEffect, useMemo, useState, useReducer} from "react";
import {connect} from 'react-redux'
import {withRouter} from "react-router";
import {DemandValidation, DemandValidationKeys} from 'constants/DemandValidation';
import Loading from "components/Loading";
import Tr from "translations/Translations";
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {makeStyles} from "@material-ui/core";
import FinishDemandService from "services/FinishDemandService";
import RouterPath from "libs/RouterPath";
import Confirm from "components/popup/confirm/Confirm";
import {LABELS as ProcedureStatusLabels, VALUES as ProcedureStatusValues} from "constants/ProcedureStatus";
import UnpublishNoticePopup from "./components/UnpublishNoticePopup";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import useSnackbar from "hooks/useSnackbar";
import {shareSystemsConnected} from "libs/shareSystems";
import iconWorksReducer from "libs/iconWorksReducer";


const useStyle = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    icon: theme.components.icon,
    italic: {
        fontStyle: 'italic',
    },
    text: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(4)
    },
    exPostButton: {
        marginBottom: theme.spacing(1)
    },
    exPostBackButton: {
        marginTop: theme.spacing(4)
    },
    deletedSection: {
        marginTop: theme.spacing(2)
    }
}))

const rp = RouterPath.myProcedure;

function FinishDemandPanel(
    {
        match,
        demandValidation,
        finishDemand,
        demandHeader
    }) {

    const classes = useStyle();
    const curDemandValidation = DemandValidation.FINISH_DEMAND;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === curDemandValidation);
    const editable = section ? section.editable : false;
    const [backConfirm, setBackConfirm] = useState(false);
    const [backToResultConfirm, setBackToResultConfirm] = useState(false);
    const [unpublishDatePopup, setUnpublishDatePopup] = useState(false);
    const [deleteSharePointConfirm, setDeleteSharePointConfirm] = useState(false);
    const {enqueueSuccessSnackbar} = useSnackbar();
    const prevErrors = useMemo(() => demandValidation.filter((x) => x.section !== curDemandValidation && x.status === 'ERROR'), [demandValidation, curDemandValidation]);
    const connectedSystems = useMemo(() => shareSystemsConnected(demandHeader), [demandHeader]);
    const hasSharePointConnection = connectedSystems.includes('sharepoint');
    const isClosed = [ProcedureStatusValues.FINISHED, ProcedureStatusValues.CANCELLED, ProcedureStatusValues.ANNULLED].includes(finishDemand?.status);

    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        preview: false,
        download: false,
        publish: false,
        share: false,
        downloadCount: false
    });

    useEffect(() => {
        FinishDemandService.getFinishDemand(demandId);
        return () => {
            FinishDemandService.clearFinishDemand();
        }
    }, [demandId])

    const backToOfferEvaluation = () => {
        setBackConfirm(false);
        FinishDemandService.backToOfferEvaluation(demandId).then((resp) => RouterPath.redirect(RouterPath.createPath(resp?.result === 2 ? rp.steps.MP_2_ID : rp.steps.MP_3_ID, {id: demandId})))
    };

    const backToPreparing = () => {
        setBackConfirm(false);
        FinishDemandService.backToOfferEvaluation(demandId).then((resp) => RouterPath.redirect(RouterPath.createPath(rp.steps.MP_1_ID, {id: demandId})))
    };

    const backToResultNotice = () => {
        setBackToResultConfirm(false);
        FinishDemandService.backToResultNotice(demandId);
    };

    const doCancelFinish = () => {
        if (finishDemand.canCancel)
            FinishDemandService.cancelDemand(demandId);
        else if (finishDemand.canFinish)
            FinishDemandService.finishDemand(demandId);
    };
    const doCancel = () => {
        if (finishDemand.canCancel)
            FinishDemandService.cancelDemand(demandId);
    };
    const doFinish = () => {
        if (finishDemand.canFinish)
            FinishDemandService.finishDemand(demandId);
    };

    const deleteFromSharePoint = () => {
        setDeleteSharePointConfirm(false);
        dispatchIconWorks({type: 'publish', works: true});
        FinishDemandService.deleteFromSharePoint(demandId).then((resp) => {
            if (resp) {
                FinishDemandService.getFinishDemand(demandId);
                enqueueSuccessSnackbar(Tr('demand_finish_delete_sharepoint_success'))
            }
        }).finally(() => {
            dispatchIconWorks({type: 'publish', works: false})
        });
    };

    if (!finishDemand) return <Loading/>

    return (<div className={classes.root}>
            {!demandHeader.exPost &&
            <GridBlock
                direction='column'
                alignItems='center'

            >
                <CheckBoxIcon className={classes.icon} color='primary'/>
                {
                    prevErrors.length > 0 ?
                        <Typography className={classes.text}>{Tr('to_finish_done_sections')}:
                            "{prevErrors.map((x) => Tr(DemandValidationKeys[x.section])).join("\", \"")}"</Typography>
                        :
                        (ProcedureStatusValues.FINISHED === finishDemand.status || ProcedureStatusValues.CANCELLED === finishDemand.status) ?
                            <Typography
                                className={classes.text}>{ProcedureStatusLabels[finishDemand.status]}</Typography>
                            :
                            <Typography className={classes.text}>{Tr('demand_finish_finish_info')}</Typography>
                }

                <Button
                    onClick={doCancelFinish}
                    disabled={!editable || !(finishDemand.canCancel || finishDemand.canFinish) || prevErrors.length > 0}

                >
                    {Tr(finishDemand.status === ProcedureStatusValues.CANCELLED || finishDemand.canCancel ? 'demand_finish_cancel_button' : 'demand_finish_finish_button')}
                </Button>

                {!finishDemand.ojsResultNoticeSent && <Typography className={classes.text}>{Tr('demand_finish_back_to_evaluation_info')}</Typography>}
                {!finishDemand.ojsResultNoticeSent &&
                <Button
                    onClick={() => setBackConfirm(true)}
                    disabled={!finishDemand.canBackState}
                >
                    {Tr('demand_finish_back_to_evaluation_button')}
                </Button>
                }

                {finishDemand.ojsResultNoticeSent && <Typography className={classes.text}>{Tr('demand_finish_back_to_result_notice_info')}</Typography>}
                {finishDemand.ojsResultNoticeSent &&
                <Button
                    onClick={() => setBackToResultConfirm(true)}
                    disabled={!finishDemand.canBackToResultNotice}
                >
                    {Tr('demand_finish_back_to_result_notice_button')}
                </Button>
                }

                <Typography className={classes.text}>
                    {Tr('demand_finish_withdrawal_notice_info')}
                    {!!finishDemand.withdrawalNoticeDate && <><br/><Typography component='span' color="primary"
                                                                               className={classes.italic}>{Tr('demand_finish_withdrawal_notice_set_info', {date: moment(finishDemand.withdrawalNoticeDate).format(DateFormats.DATETIME_FORMAT)})}</Typography></>}
                </Typography>
                <Button
                    onClick={() => setUnpublishDatePopup(true)}
                    disabled={!finishDemand.canSetWithdrawalNoticeDate}
                >
                    {Tr(finishDemand.withdrawalNoticeDate ? 'demand_finish_withdraw_notice_update' : 'demand_finish_withdraw_notice')}
                </Button>
            </GridBlock>
            }

            {demandHeader.exPost &&
            <GridBlock
                direction='column'
                alignItems='center'

            >
                <CheckBoxIcon className={classes.icon} color='primary'/>
                {
                    prevErrors.length > 0 ?
                        <Typography className={classes.text}>{Tr('to_finish_done_sections')}:
                            "{prevErrors.map((x) => Tr(DemandValidationKeys[x.section])).join("\", \"")}"</Typography>
                        :
                        (ProcedureStatusValues.FINISHED === finishDemand.status || ProcedureStatusValues.CANCELLED === finishDemand.status) ?
                            <Typography
                                className={classes.text}>{ProcedureStatusLabels[finishDemand.status]}</Typography>
                            :
                            <Typography className={classes.text}>{Tr('demand_finish_finish_info_ex_post')}</Typography>
                }
                <Button
                    className={classes.exPostButton}
                    onClick={doCancel}
                    disabled={!editable || !finishDemand.canCancel || prevErrors.length > 0}
                >
                    {Tr('demand_finish_cancel_button')}
                </Button>
                <Button
                    onClick={doFinish}
                    disabled={!editable || !finishDemand.canFinish || prevErrors.length > 0}
                >
                    {Tr('demand_finish_finish_button')}
                </Button>

                <Button
                    className={classes.exPostBackButton}
                    onClick={() => setBackConfirm(true)}
                    disabled={!finishDemand.canBackState}
                >
                    {Tr('demand_finish_back_to_evaluation_button_exPost')}
                </Button>
            </GridBlock>
            }
            {isClosed && hasSharePointConnection && finishDemand?.sharepointConnected &&
            <GridBlock
                className={classes.deletedSection}
                direction='column'
                alignItems='center'
            >
                <Typography className={classes.text}>{Tr('demand_finish_closed_info')}</Typography>
                <Button
                    onClick={() => setDeleteSharePointConfirm(true)}
                    disabled={iconWorks.anyWorks}
                    working={iconWorks.publish}
                >
                    {Tr('demand_finish_delete_sharepoint')}
                </Button>
            </GridBlock>
            }
            <Confirm
                confirmText={demandHeader && demandHeader.exPost ? 'demand_finish_back_to_evaluation_confirm_message_exPost' : 'demand_finish_back_to_evaluation_confirm_message'}
                open={backConfirm}
                onConfirm={demandHeader && demandHeader.exPost ? backToPreparing : backToOfferEvaluation}
                onCancel={() => setBackConfirm(false)}
            />
            <Confirm
                confirmText='demand_finish_back_to_result_notice_confirm_message'
                open={backToResultConfirm}
                onConfirm={backToResultNotice}
                onCancel={() => setBackToResultConfirm(false)}
            />
            <Confirm
                confirmText='demand_finish_delete_sharepoint_confirm'
                open={deleteSharePointConfirm}
                onConfirm={deleteFromSharePoint}
                onCancel={() => setDeleteSharePointConfirm(false)}
            />
            {
                unpublishDatePopup && <UnpublishNoticePopup
                    demandId={demandId}
                    onSuccess={() => {
                        FinishDemandService.getFinishDemand(demandId).finally(() => setUnpublishDatePopup(false));
                    }}
                    onCancel={() => setUnpublishDatePopup(false)}
                    initialDate={finishDemand.withdrawalNoticeDate}
                />
            }
        </div>
    )
}


export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    finishDemand: state.resources[FinishDemandService.FINISH_DEMAND_RESOURCE_ID],
    demandHeader: state.resources.demandHeader
}), {})(withRouter(FinishDemandPanel));